import React from "react";
import ScrubberAvailableQuantityInput from "../ScrubberAvailableQuantityInput";
import AvailableQuantityInput from "../AvailableQuantityInput";
import useAuth from "../../../hooks/useAuth";

const AvailableQuantityField = ({
  type,
  display,
  asset,
  disabledForm,
  onRestockInventory,
  availableQuantityComponent,
  sameLocation,
}) => {
  const { user } = useAuth();
  const isItem = type === "item";

  if (type === "scrubber") {
    return (
      <ScrubberAvailableQuantityInput
        display={display}
        user={user}
        asset={asset}
        disabledForm={disabledForm}
      />
    );
  }

  return (
    <AvailableQuantityInput
      type={type}
      display={display}
      user={user}
      asset={asset}
      disabledForm={disabledForm}
      onRestockInventory={onRestockInventory}
      component={isItem ? availableQuantityComponent : undefined}
      sameLocation={sameLocation}
    />
  );
};

export default AvailableQuantityField;
